import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@/components/Text";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { formatFullName } from "@/data/persons";
import { formatPhone } from "@/data/phones";
import { Flex } from "@/eworkitComponents";
import { Avatar } from "@/views/components/Person";

export interface IContactPersonCard {
  consultantProfile: IConsultantProfile;
}

export const ContactPersonCard: FC<IContactPersonCard> = memo(({ consultantProfile }) => {
  const { t } = useTranslation("session");

  return (
    <Flex innerMargin="md">
      <Flex>
        <Avatar
          firstName={consultantProfile.firstName}
          lastName={consultantProfile.lastName}
          avatar={consultantProfile.avatar}
          size="xl"
        />
      </Flex>

      <Flex direction="column" innerMargin="xs">
        <Text size="lg" weight="bold">
          {t("ASSIGNMENTS.DETAILS.CONTACT_PERSON.SECTION_HEADER")}
        </Text>
        <Text>{formatFullName(consultantProfile)}</Text>
        <Text>{consultantProfile.email}</Text>
        <Text>{formatPhone(consultantProfile.phone)}</Text>
      </Flex>
    </Flex>
  );
});
